module.exports = __webpack_public_path__ + "static/media/texture-gray.80efcdf5.png";